// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jeiWVYftCluN9Mc0l5qs{height:22px;width:35px}", "",{"version":3,"sources":["webpack://./src/shared/styles/Header.module.scss"],"names":[],"mappings":"AACA,sBACI,WAAA,CACA,UAAA","sourcesContent":["\n.headerIcon {\n    height: 22px;\n    width: 35px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerIcon": "jeiWVYftCluN9Mc0l5qs"
};
export default ___CSS_LOADER_EXPORT___;
